import { Subject } from 'rxjs';
import { BaseProvider } from 'src/app/core/services/base-provider';
import * as i0 from "@angular/core";
import * as i1 from "./globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "./ls-helper.service";
import * as i4 from "./auth.service";
import * as i5 from "./utils.service";
export class TermsAndConditionsService extends BaseProvider {
    constructor(globals, http, ls, authService, utilsService) {
        super();
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.authService = authService;
        this.utilsService = utilsService;
        this.userAcceptedTerms = new Subject();
        this.termsIsVisible = false;
        this.userAcceptsTerms = false;
        this.baseUrl = 'processTypeTerm';
    }
    getTerms(userProcessId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/' + userProcessId;
            this.http.get(this.url).subscribe((data) => {
                this.terms = data.Data;
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
}
TermsAndConditionsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TermsAndConditionsService_Factory() { return new TermsAndConditionsService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LsHelperService), i0.ɵɵinject(i4.AuthService), i0.ɵɵinject(i5.UtilsService)); }, token: TermsAndConditionsService, providedIn: "root" });
